import React from "react";
import Table from "../../suppliers/Suppliermanagment/Table/Table";

function TableData() {
  const data = [
    {
      job_id: "1",
      customer: "MRP",
      sch_name: "Zeire Gadtid",
      report: "13-03-2022",
      status: "Issue",
    },
    {
      job_id: "2",
      customer: "White Light",
      sch_name: "Zeire Gadtid",
      report: "13-03-2022",
      status: "Issue",
    },
    {
      job_id: "32",
      customer: "White Light",
      sch_name: "Zeire Gadtid",
      report: "13-03-2022",
      status: "Issue",
    },
    {
      job_id: "52",
      customer: "MRP",
      sch_name: "Zeire Gadtid",
      report: "13-03-2022",
      status: "Issue",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Job ID",
        accessor: "job_id",
      },
      {
        Header: "Customer",
        accessor: "customer",
      },
      {
        Header: "Schedule Name",
        accessor: "sch_name",
      },
      {
        Header: "Deadline",
        accessor: "report",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (value) => (
          <button>
            {" "}
            Issue
            <svg
              className="ml-8 float-right"
              version="1.1"
              id="Uploaded to svgrepo.com"
              xmlns="http://www.w3.org/2000/svg"
              fill="red"
              width="32px"
              height="32px"
              viewBox="0 0 32 32"
            >
              <path
                class="puchipuchi_een"
                d="M30.211,23.98L17.798,3.034c-0.81-1.366-2.787-1.366-3.596,0L1.789,23.98
           C0.999,25.314,1.96,27,3.51,27h24.98C30.04,27,31.001,25.314,30.211,23.98z M16,24c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2
           s2,0.895,2,2C18,23.105,17.105,24,16,24z M18,13.377c0,1.075-0.173,2.143-0.513,3.162l-0.171,0.512C17.127,17.618,16.597,18,16,18
           s-1.127-0.382-1.316-0.949l-0.171-0.512C14.173,15.52,14,14.452,14,13.377v-2.99C14,9.621,14.621,9,15.387,9h1.225
           C17.379,9,18,9.621,18,10.387V13.377z"
              />
            </svg>
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-4 -mt-2">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-10">
        <div className="-mt-8">
        
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
